import { render } from "./Touch.vue?vue&type=template&id=bfef8df2&scoped=true"
import script from "./Touch.vue?vue&type=script&lang=js"
export * from "./Touch.vue?vue&type=script&lang=js"

import "./Touch.vue?vue&type=style&index=0&id=bfef8df2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfef8df2"]])

export default __exports__